import { ChangeDetectorRef, Component, OnInit, ViewChild, inject } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CadastroService } from '../../../../../services/cadastro.service';
import { VendaCliente } from '../../../../../models/cadastro.model';
import { FinanceiroService } from '../../../../../services/financeiro.service';
import { ErrorModel } from '../../../../../models/error.model';
import { OrcamentoPdfComponent } from '../../../../financeiro/components/orcamentos.component/orcamento-pdf.component';

@Component({
  selector: 'app-cliente-vendas',
  standalone: true,
  imports: [CommonModule, CurrencyPipe, OrcamentoPdfComponent],
  templateUrl: './cliente-vendas.component.html',
  styleUrls: ['./cliente-vendas.component.css']
})
export class ClienteVendasComponent implements OnInit {
  clienteId!: number;
  vendas: VendaCliente[] = [];
  paginatedVendas: VendaCliente[] = [];
  imprimindoId: number | null = null;

  currentPage = 1;
  itemsPerPage = 10;
  totalPages = 1;
  pages: number[] = [];

  @ViewChild(OrcamentoPdfComponent) private orcamentoPdfComponent?: OrcamentoPdfComponent;

  private cdr = inject(ChangeDetectorRef);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cadastroService: CadastroService,
    private financeiroService: FinanceiroService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id) {
        this.clienteId = +id;
        this.loadVendas();
      }
    });
  }

  loadVendas(): void {
    this.cadastroService.getVendasByCliente(this.clienteId).subscribe({
      next: data => {
        this.vendas = data;
        this.refreshPagination();
      },
      error: () => {
        this.toastr.error('Erro ao carregar vendas do cliente.');
      }
    });
  }

  refreshPagination(): void {
    this.totalPages = Math.max(1, Math.ceil(this.vendas.length / this.itemsPerPage));
    this.updatePageNumbers();
    this.setPage(1);
  }

  updatePageNumbers(): void {
    this.pages = Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }

  setPage(page: number): void {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    const start = (page - 1) * this.itemsPerPage;
    this.paginatedVendas = this.vendas.slice(start, start + this.itemsPerPage);
  }

  formatarData(data: string): string {
    if (!data) return '-';
    const [datePart] = data.split('T');
    const [ano, mes, dia] = datePart.split('-');
    return `${dia}/${mes}/${ano}`;
  }

  imprimirEspelho(idOrcamento: number): void {
    this.imprimindoId = idOrcamento;
    this.financeiroService.getEspelhoOrcamento(idOrcamento).subscribe({
      next: (espelho) => {
        this.orcamentoPdfComponent?.printOrcamento(espelho);
        this.imprimindoId = null;
        this.cdr.detectChanges();
      },
      error: (err) => {
        const erro: ErrorModel = err.error ?? { message: 'Erro ao gerar espelho do orçamento.' };
        this.toastr.error(erro.message ?? 'Erro ao gerar espelho do orçamento.');
        this.imprimindoId = null;
        this.cdr.detectChanges();
      }
    });
  }

  voltar(): void {
    this.router.navigate(['/home', 'cadastro-cliente']);
  }
}
